module.exports = __webpack_public_path__ + "img/food-video-thumb.2031e573.png";